import "./App.css";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Problem from "./components/Problem";
import Stack from "./components/Stack";
import SocialProof from "./components/SocialProof";
import Results from "./components/Results";
import HowItWorks from "./components/HowItWorks";
import DatabaseReactivationPage from "./components/DatabaseReactivationPage";
import Pricing from "./components/Pricing";
import Comparison from "./components/Comparison";
import Bio from "./components/Bio";
import TradesGrid from "./components/TradesGrid";
import FreeAudit from "./components/FreeAudit";
import FinalCTA from "./components/FinalCTA";
import LeadSection from "./components/LeadSection";
import Footer from "./components/Footer";
import TradePage from "./components/TradePage";
import Blog from "./components/Blog";
import BlogPost from "./components/BlogPost";
import AdminLeads from "./components/AdminLeads";
import ChatWidget from "./components/ChatWidget";
import SEO from "./components/SEO";

function Home() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <>
      <SEO
        title=""
        description="LightSpeed ROI builds websites for free for home service pros. A system that answers the phone, texts them back, and books the job. $597/mo, cancel anytime."
        path="/"
      />
      <Navbar />
      <main>
        <Hero />
        <Problem />
        <Stack />
        <SocialProof />
        <Results />
        <HowItWorks />
        <Pricing />
        <Comparison />
        <Bio />
        <TradesGrid />
        <FreeAudit />
        <LeadSection />
        <FinalCTA />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/database-reactivation" element={<DatabaseReactivationPage />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/admin-leads" element={<AdminLeads />} />
            <Route path="/:slug" element={<TradePage />} />
          </Routes>
          <ChatWidget />
        </BrowserRouter>
        <Toaster />
      </div>
    </HelmetProvider>
  );
}

export default App;
